:host {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid $color-black;
  position: absolute;
  z-index: 1;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ux-icon {
  font-size: 30px;
}

button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  right: 0;
  bottom: 0;
  border: 0;
  outline: 0;
  background: $color-white;
  position: absolute;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.15s ease-in-out;

  .ux-icon {
    font-size: 18px;
  }
}

:host(:hover),
:host(:focus) {
  button {
    cursor: pointer;
    opacity: 1;
  }
}
